import { useState } from 'react';
import { Link, Routes, Route } from 'react-router-dom';
import '../combined-calculator.min.css';
import '../splide.min.css';
import '../App.css';
import EURoulette from '../Components/EURoulette';
import USARoulette from '../Components/USARoulette';

function Roulette() {

    return (
        <div className='grey-bg h-screen mainWrapper'>
            <div class="text-center">
                <span
                    class="nutmeg uppercase text-2xl md:text-3xl lg:text-5xl xl:text-7xl p-2 md:p-4 text-white text-white font-extrabold bg-bovadablue text-center inline-block m-4 md:my-6 md:mx-12 leading-none">
                    Calculate your payouts
                </span>
            </div>

            <div className='rouletteContent'>
                <Routes basename="/games/BVD/default/bovada-roulette/roulette">
                    <Route exact path='/usa' element={<USARoulette />} />
                    <Route exact path='/eu' element={<EURoulette />} />
                </Routes>
            </div>
        </div>
    );
}

export default Roulette;